<template>
  <div
    class="eventComp_mode_5 eventComp_mode_container"
    v-show="currThemeObj && tableGroup && isShowMode_5"
  >
    <span class="eventComp_mode_title" v-text="'技术统计'"></span>
    <div class="tableGroup" v-for="group in tableGroup" :key="group.key">
      <div class="groupInfor">
        <span class="groupInfor_logo" :class="group.team_logo ? 'isLogo' : ''">
          <img v-if="group.team_logo" :src="group.team_logo" />
        </span>
        <span
          class="groupInfor_name"
          v-text="_valPerFormatHandler(group.team_name)"
          @click="goDetail('CSMeetDelegationDetailIndex', group)"
        ></span>
      </div>
      <mergeHeadCel_tablel
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="currModeName"
        :columnColorPropArr="columnColorPropArr"
        :textAlignleftPropArr="textAlignleftPropArr"
        :tableColumnData="tableColumnData"
        :tableData="group.tableData"
        :isSummaryFlag="false"
        v-show="group.tableData && group.tableData.length > 0"
      ></mergeHeadCel_tablel>
    </div>
  </div>
</template>

<script>
// 适用： 篮球 主客队 技术统计 表格（头部合并单元格，底部合并总计）
import mergeHeadCel_tablel from '@components/platfromBase/compreSportsMeet/table/mergeHeadCel_tablel.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_5',
  components: {
    mergeHeadCel_tablel,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_5 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      //   tableMode: 'eventComp_mode_5',
      currModeName: '',
      renderModeList: [
        {
          modeName: 'eventComp_mode_5_BKB',
          sportsIdArr: ['BKB'],
          tableGroup: ['home', 'away'],
          tableColumnData: [
            {
              prop: 'bib_number',
              id: 'bib_number',
              label: 'No.',
              widthVw: 3.75,
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            },
            {
              prop: 'single-player-name',
              id: 'single-player-name',
              label: '运动员',
              //   widthVw: 25.42, //对应列的宽度，单位vw
              //   widthPx: Math.floor(25.42 * this.vw2px),
              className: 'columnTextLeftClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            },
            {
              prop: '',
              id: 'fieldGoals',
              label: 'Field Goals',
              isAssignFlag: true,
              child: [
                {
                  prop: 'stringAddition_FieldGoals_MA',
                  label: 'M/A',
                  originVal: ['field_goals'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'averageValue_FieldGoals_rate',
                  label: '%',
                  originVal: ['field_goals_rate'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
              ],
            },
            {
              prop: '',
              id: 'towPoints',
              label: '2 Points',
              isAssignFlag: true,
              child: [
                {
                  prop: 'stringAddition_2_Point_MA',
                  label: 'M/A',
                  originVal: ['two_point_shots'],
                  widthVw: 3.75,
                },
                {
                  prop: 'averageValue_2_Point_rate',
                  originVal: ['two_point_shots_rate'],
                  label: '%',
                  widthVw: 3.75,
                },
              ],
            },
            {
              prop: '',
              id: 'threePoints',
              label: '3 Points',
              isAssignFlag: true,
              child: [
                {
                  prop: 'stringAddition_3Point_MA',
                  label: 'M/A',
                  originVal: ['three_point_shots'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'averageValue_3Point_rate',
                  originVal: ['three_point_shots_rate'],
                  label: '%',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
              ],
            },
            {
              prop: '',
              id: 'freeThrows',
              label: 'FreeThrows',
              isAssignFlag: true,
              child: [
                {
                  prop: 'stringAddition_freeThrows_MA',
                  label: 'M/A',
                  originVal: ['free_throws'],
                  widthVw: 3.75,
                },
                {
                  prop: 'averageValue_freeThrows_rate',
                  originVal: ['free_throws_rate'],
                  label: '%',
                  widthVw: 3.75,
                },
              ],
            },
            {
              prop: '',
              id: 'rebounds',
              label: 'Rebounds',
              child: [
                {
                  prop: 'or',
                  label: 'OR',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'dr',
                  label: 'DR',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'tot',
                  label: 'TOT',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
              ],
            },
            {
              prop: 'as',
              id: 'as',
              label: 'AS',
              widthVw: 3.75,
            },
            {
              prop: 'to',
              id: 'to',
              label: 'TO',
              widthVw: 3.75,
            },
            {
              prop: 'st',
              id: 'st',
              label: 'ST',
              widthVw: 3.75,
            },
            {
              prop: 'bs',
              id: 'bs',
              label: 'BS',
              widthVw: 3.75,
            },
            {
              prop: 'pf',
              id: 'pf',
              label: 'PF',
              widthVw: 3.75,
            },
            {
              prop: 'fd',
              id: 'fd',
              label: 'FD',
              widthVw: 3.75,
            },
            {
              prop: 'pts',
              id: 'pts',
              label: 'PTS',
              widthVw: 3.75,
            },
          ],
          columnColorPropArr: [
            'stringAddition_FieldGoals_MA',
            'averageValue_FieldGoals_rate',
            'stringAddition_3Point_MA',
            'averageValue_3Point_rate',
            'or',
            'dr',
            'tot',
          ],
          textAlignleftPropArr: ['single-player-name'],
          datasChildKey: 'athleteStats', //datas下需要的数据字段
        },
        {
          modeName: 'eventComp_mode_5_WPO',
          sportsIdArr: ['WPO'],
          tableGroup: ['home', 'away'],
          tableColumnData: [
            {
              prop: 'bib_number',
              id: 'bib_number',
              label: 'No.',
              widthVw: 3.75,
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            },
            {
              prop: 'single-player-name',
              id: 'single-player-name',
              label: '运动员',
              //   widthVw: 25.42, //对应列的宽度，单位vw
              //   widthPx: Math.floor(25.42 * this.vw2px),
              className: 'columnTextLeftClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            },
            {
              prop: '',
              id: 'ScoreAndShoot',
              label: '得分/射门',
              isAssignFlag: true,
              child: [
                {
                  prop: 'stringAddition_total',
                  label: '总计',
                  originVal: ['total'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'averageValue_goals_rate',
                  label: '%',
                  originVal: ['goals_rate'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_A',
                  label: 'A',
                  originVal: ['A'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_C',
                  label: 'C',
                  originVal: ['C'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_X',
                  label: 'X',
                  originVal: ['X'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_6m',
                  label: '6m',
                  originVal: ['6m'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_PS',
                  label: 'PS',
                  originVal: ['PS'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'stringAddition_CA',
                  label: 'CA',
                  originVal: ['CA'],
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
              ],
            },
            {
              prop: 'ST',
              id: 'ST',
              label: 'ST',
              widthVw: 3.75,
            },
            {
              prop: 'BL',
              id: 'BL',
              label: 'BL',
              widthVw: 3.75,
            },
            {
              prop: 'stringAddition_SP',
              id: 'SP',
              label: 'SP',
              isAssignFlag: true,
              originVal: ['SP'],
              widthVw: 3.75,
            },
            {
              prop: '',
              id: 'personalFoul',
              label: '个人犯规',
              isAssignFlag: false,
              child: [
                {
                  prop: 'C20',
                  label: '20C',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'F20',
                  label: '20F',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'TF',
                  label: 'TF',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'PF',
                  label: 'PF',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
                {
                  prop: 'EX',
                  label: 'EX',
                  widthVw: 3.75,
                  className: 'columnHightBgClass',
                },
              ],
            },
          ],
          columnColorPropArr: [
            'stringAddition_total',
            'averageValue_goals_rate',
            'stringAddition_A',
            'stringAddition_C',
            'stringAddition_X',
            'stringAddition_6m',
            'stringAddition_PS',
            'stringAddition_CA',
            'F20',
            'C20',
            'TF',
            'PF',
            'EX',
          ],
          textAlignleftPropArr: ['single-player-name'],
          datasChildKey: 'athleteStats', //datas下需要的数据字段
        },
        {
          modeName: 'eventComp_mode_5_VVO',
          sportsIdArr: ['VVO'],
          tableGroup: ['home', 'away'],
          tableColumnData: [],
          columnColorPropArr: [],
          textAlignleftPropArr: ['player_name'],
          datasChildKey: 'athleteStats', //datas下需要的数据字段
        },
        {
          modeName: 'eventComp_mode_5_CUR',
          sportsIdArr: ['CUR', 'IHO'],
          tableGroup: ['home', 'away'],
          tableColumnData: [],
          columnColorPropArr: [],
          textAlignleftPropArr: ['player_name'],
          datasChildKey: 'athleteStats', //datas下需要的数据字段
        },
      ],
      tableGroup: null,
      tableColumnData: [],
      columnColorPropArr: [],
      textAlignleftPropArr: [],
    }
  },
  computed: {
    isShowMode_5() {
      let flag = false

      if (this.tableGroup && this.tableGroup.length > 0) {
        this.tableGroup.forEach((group) => {
          if (group.tableData && group.tableData.length > 0) {
            flag = true
          }
        })
      }
      return flag
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
              this.columnColorPropArr = modeItem.columnColorPropArr
              this.textAlignleftPropArr = modeItem.textAlignleftPropArr
              this.tableColumnData = modeItem.tableColumnData

              if (
                ['VVO', 'CUR', 'IHO'].includes(this.currSportsDetail.sportsId)
              ) {
                this.tableColumnData = this.datas[
                  modeItem.datasChildKey
                ].table_head.map((headColumn) => {
                  if (headColumn.map_key_arr[0] === 'player_name') {
                    return {
                      prop: 'single-player-name',
                      id: 'single-player-name',
                      label: '运动员',
                      //   widthVw: 25.42, //对应列的宽度，单位vw
                      //   widthPx: Math.floor(25.42 * this.vw2px),
                      className: 'columnTextLeftClass', //单独定制的头部样式class
                      // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                    }
                  } else {
                    return {
                      prop: headColumn.map_key_arr[0],
                      id: headColumn.map_key_arr[0],
                      label: headColumn.name,
                      widthVw: 6.94,
                    }
                  }
                })
              }

              if (
                this.currSid === 'ASG2026' &&
                ['WPO'].includes(this.currSportsDetail.sportsId)
              ) {
                this.tableColumnData = this.datas[
                  modeItem.datasChildKey
                ].table_head.map((headColumn) => {
                  const widthVw = Math.max(headColumn.name?.length * 1.2, 6.94)
                  return {
                    prop: headColumn.map_key_arr[0],
                    id: headColumn.map_key_arr[0],
                    label: headColumn.name,
                    widthVw: widthVw,
                  }
                })
              }

              console.debug('mode_5', this.tableColumnData)
              // 篮球 modeItem.datasChildKey:athleteStats
              this.tableGroup = modeItem.tableGroup.map((groupKey) => {
                console.debug(
                  'mode_5',
                  groupKey,
                  this.datas[groupKey].team_name,
                  modeItem.datasChildKey
                )
                let groupData = {
                  key: groupKey,
                  data: this.datas[modeItem.datasChildKey]
                    ? JSON.parse(
                        JSON.stringify(
                          this.datas[modeItem.datasChildKey][groupKey]
                        )
                      )
                    : [],
                  baseInfo: {
                    team_name: this.datas[groupKey].team_name,
                    team_eng: this.datas[groupKey].team_eng,
                    team_logo: this.datas[groupKey].team_logo,
                    team_id: this.datas[groupKey].team_id
                      ? this.datas[groupKey].team_id
                      : '',
                  },
                }
                return this.computedModeData(groupData)
              })
            }
          })
        }
      })
    },
    goDetail(routerName, item, id) {
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    computedModeData(data) {
      // console.debug('computedModeData:', data)
      if (data && data.data) {
        let tableData = data.data.map((rowData) => {
          this.tableColumnData.forEach((columnItem) => {
            if (columnItem.widthVw) {
              columnItem.widthPx = Math.floor(columnItem.widthVw * this.vw2px)
            }

            if (columnItem.child) {
              columnItem.child.forEach((childItem) => {
                if (childItem.widthVw) {
                  childItem.widthPx = Math.floor(childItem.widthVw * this.vw2px)
                }
                if (columnItem.isAssignFlag) {
                  // console.debug('columnItem:', columnItem)
                  if (childItem.originVal.length > 1) {
                    let originValArr = []
                    childItem.originVal.forEach((originItem) => {
                      originValArr.push(rowData[originItem])
                    })
                    rowData[childItem.prop] = originValArr.join('/')
                  } else {
                    rowData[childItem.prop] = rowData[childItem.originVal[0]]
                  }
                }
              })
            } else {
              if (columnItem.isAssignFlag) {
                rowData[columnItem.prop] = rowData[columnItem.originVal[0]]
              }
            }
          })
          return rowData
        })
        console.debug('mode_5 this.tableData:', tableData, this.tableColumnData)
        const { team_logo, team_name, team_id, team_eng } = data.baseInfo
        return {
          key: data.key,
          tableData,
          team_logo,
          team_name,
          team_id,
          team_eng,
        }
      } else {
        console.debug('暂无数据')
        return this.notDataHandler(data.key)
      }
    },
    notDataHandler(key) {
      return {
        key: key,
        tableData: [],
        team_logo: '',
        team_name: '',
        team_id: '',
        team_eng: '',
      }
      //   this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .eventComp_mode_title {
    display: block;
    font-size: 1.11vw;
    line-height: 2.788vw;
    font-weight: bold;
    color: var(--mixtmt_mainColor5);
  }
  .tableGroup {
    position: relative;
    width: 100%;
    padding-bottom: 1.388vw;
    .groupInfor {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 3.47vw;
      margin-bottom: 0.694vw;
      .groupInfor_logo {
        width: 2.91vw;
        height: 1.94vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .groupInfor_name {
        width: auto;
        padding: 0 2.083vw;
        font-size: 1.11vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
    }
  }
}

.mixtmt_pc {
  .eventComp_mode_container {
    .tableGroup {
      .groupInfor {
        .groupInfor_name {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
